export default __webpack_public_path__ + "static/media/Cooling-Tower-Fill-Before-After-RYDLYME-scaled.eead0c76.jpg";